// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC5igipU4wMyrQ_yv0mgEs3kGVea1ON3uc",
  authDomain: "nicoliniref.firebaseapp.com",
  projectId: "nicoliniref",
  storageBucket: "nicoliniref.appspot.com",
  messagingSenderId: "867942643366",
  appId: "1:867942643366:web:9edef8f329bf148c97e667"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);